module.exports = __webpack_public_path__ + "static/media/vagas-hero.0b2a700e.png";